// extracted by mini-css-extract-plugin
export default {"expireMessageArea":"ProductExpirationMessages_expireMessageArea__w08SE"};